import { isRetryableResult, mergeImageRequests } from '../utils/generation-retry.js';
import { restoredGenerationRun } from '../utils/generation-restore.js';

export const generationRun = $state({
  request: null,
  attemptId: null,
  attemptSlotIds: [],
  quote: null,
  queue: null,
  status: 'idle',
  results: {}
});

export function restoreGenerationRun(snapshot) {
  Object.assign(generationRun, restoredGenerationRun(snapshot));
}

export function prepareGenerationRun(request, quote = null, results = null) {
  if (generationRun.request?.id !== request.id) {
    generationRun.results = {};
    generationRun.attemptId = null;
    generationRun.attemptSlotIds = [];
    generationRun.queue = null;
  }
  if (results) generationRun.results = { ...generationRun.results, ...results };
  generationRun.request = mergeImageRequests(generationRun.request, request);
  generationRun.quote = quote;
  generationRun.status = 'reviewing';
}

export function recordGenerationEvent(message) {
  if (message.type === 'request:started') {
    generationRun.attemptId = message.requestId;
    generationRun.attemptSlotIds = message.request.slots.map(slot => slot.id);
    generationRun.request = mergeImageRequests(generationRun.request, message.request);
    const results = { ...generationRun.results };
    for (const slot of message.request.slots) {
      const previous = results[slot.id];
      if (!isRetryableResult(previous)) continue;
      results[slot.id] = { slotId: slot.id, manifestId: message.request.id, requestId: message.requestId,
        batchIndex: slot.batchIndex, imageIndex: slot.imageIndex, prompt: slot.prompt,
        model: slot.modelId, projectConfig: slot.projectConfig, seed: slot.projectConfig.seed,
        status: 'unsubmitted', projectId: null, url: null, unverified: false,
        selected: previous?.selected ?? false, rating: previous?.rating ?? 0 };
    }
    generationRun.results = results;
    generationRun.status = 'generating';
    generationRun.queue = { status: 'preparing', pending: message.request.slots.length,
      submitted: 0, active: 0, paused: 0, completed: 0, capacity: null, notice: null };
    return;
  }
  if (message.requestId !== generationRun.attemptId) return;
  if (message.type === 'generate:queue-updated') {
    generationRun.queue = { ...generationRun.queue, ...message.queue };
    return;
  }
  if (message.type === 'generate:cancel-unconfirmed') {
    generationRun.queue = { ...generationRun.queue, notice: message.message };
    return;
  }
  if (message.slotId) {
    const status = message.type === 'generate:image-completed' ? 'done'
      : message.type === 'generate:image-failed' ? (message.unverified ? 'unverified' : 'error')
      : message.type === 'generate:image-preview' ? 'rendering'
      : message.type === 'generate:image-created' ? (message.unverified ? 'unverified'
        : message.projectStatus === 'processing' ? 'rendering' : message.projectStatus === 'queued' ? 'queued' : 'pending')
      : message.type === 'generate:image-status' ? ({ pending: 'pending', queued: 'queued', processing: 'rendering' }[message.projectStatus] || null)
      : message.type === 'generate:image-canceled' ? 'canceled'
      : message.type === 'generate:image-paused' ? 'paused'
      : message.type === 'generate:image-submitting' ? 'submitting' : null;
    if (status) {
      if (generationRun.results[message.slotId]?.status === 'done' && status !== 'done') return;
      generationRun.results = { ...generationRun.results, [message.slotId]: {
        ...generationRun.results[message.slotId], ...message, status,
        url: message.imageUrl || message.previewUrl || generationRun.results[message.slotId]?.url || null
      } };
    }
  }
  if (message.type === 'generate:completed') generationRun.status = message.status || 'completed';
  if (message.type === 'error') {
    generationRun.status = message.status || 'error';
    if (message.status === 'paused') {
      generationRun.quote = null;
      generationRun.attemptId = null;
      generationRun.attemptSlotIds = [];
    }
  }
}
